import { matchPath } from 'react-router-dom';

export const NAV_GROUPS = {
    qa: [
        '/qmrs',
        '/qmrs/*',
        '/nqrs',
        '/nqrs/*',
        '/escalations',
        '/escalations/*',
        '/investigations',
        '/investigations/*',
    ],
    ssm5: ['/ssm5', '/vin/:vin/ssm5', '/vin/:vin/ssm5/ffd'],
} as const;

export type NavGroup = keyof typeof NAV_GROUPS;

export function isNavRouteActive(group: NavGroup, pathname: string): boolean {
    return NAV_GROUPS[group].some((pattern) => matchPath(pattern, pathname));
}
